<template>
  <div>
    <v-divider class="my-3"></v-divider>
    <p class="text-center primary--text mb-0">
      Resultados 1 a {{ length }} de
      {{ total }}
    </p>
  </div>
</template>
<script>
export default {
  props: {
    length: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    }
  }
}
</script>
